import { Capacitor } from '@capacitor/core';
import { Directory, Filesystem } from '@capacitor/filesystem';
import { Share } from '@capacitor/share';
import { delay, map, Observable, of, tap } from 'rxjs';

export function assign(obj: Object, prop: string, value: any) {
  obj[prop] = value;
}

export function round(value: number, precision?: number): number {
  var multiplier = Math.pow(10, precision || 0);
  return Math.round(value * multiplier) / multiplier;
}

export function isTouchDevice(): boolean {
  return 'ontouchstart' in window || navigator.maxTouchPoints > 0;
}

export function blobToBase64(file: File): Promise<string | ArrayBuffer | null> {
  console.log('blobToBase64', file);
  return new Promise((resolve, _) => {
    const reader = new FileReader();
    reader.onload = (e: any) => resolve(e.target.result);
    reader.readAsArrayBuffer(file);
  });
}


export function downloadFile(file: File): Observable<any> {
  return of(file)
      .pipe(
        map((blob: Blob) => URL.createObjectURL(blob)),
        tap((url: string) => _openLink(url, file.name)),
        delay(5000),
        tap((url: string) => window.URL.revokeObjectURL(url))
      );
}

export function downloadMobileFile(file: File): Observable<any> {
  return of(file)
      .pipe(
        map((blob: Blob) => {
          console.log('downloadMobileFile-blob', blob);
          // const blobToBase64 = this.fileBlobToBase64(blob);
          // console.log('downloadMobileFile-blobToBase64', blobToBase64);
          // const blobUrl = URL.createObjectURL(blob);
          // console.log('downloadMobileFile-blobUrl', blobUrl);
          // const uri = 'data:application/pdf;base64,' + blobToBase64;
          // console.log('downloadMobileFile-uri', uri);
          // this._openLink(uri, file.name);
          const data = blob;
          const fileName = file.name;
          if (Capacitor.getPlatform() !== 'web') {
            let dataForDownload: any;
            const reader = new FileReader();
            reader.readAsDataURL(data);
            reader.onloadend = async () => {
                dataForDownload = reader.result;

                try {
                    const directory =
                        Capacitor.getPlatform() === 'ios'
                            ? Directory.Documents
                            : Directory.External;
                    await Filesystem.requestPermissions();
                    await Filesystem.appendFile({
                        path: `Download/${fileName}`,
                        data: dataForDownload,
                        directory: directory
                    });
                    const finalUri = await Filesystem.getUri({
                        directory: directory,
                        path: `Download/${fileName}`
                    });

                    // if (Capacitor.getPlatform() === 'ios') {
                    //     Share.share({
                    //         title: fileName,
                    //         url: finalUri.uri
                    //     })
                    //         .then(() => {
                    //             console.log('File has been downloaded');
                    //         })
                    //         .catch(e => {
                    //           console.error('An error occurred during the download', e);
                    //         });
                    // } else {
                    //     if (finalUri.uri !== '') {
                    //         console.log('File has been downloaded to the Download folder');
                    //     }
                    // }
                } catch (e) {
                    console.error('An error occurred during the download', e);
                }
            };
        } else {
            this.downloadFromBrowser(data, fileName);
        }
        })
      );
}

export function downloadFromBrowser(blob: Blob, filename: string) {
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');

  a.href = url;
  a.download = filename || 'download';
  const clickHandler = () => {
      setTimeout(() => {
          URL.revokeObjectURL(url);
          removeEventListener('click', clickHandler);
      }, 150);
  };
  a.addEventListener('click', clickHandler, false);
  a.click();

  console.log('File has been downloaded to the Downloads folder.');
}

function _openLink(url: string, fileName: string): void {
  const a: HTMLAnchorElement = document.createElement('a');
  // Firefox requires the link to be in the body
  document.body.appendChild(a);
  a.style.display = 'none';
  a.href = url;
  a.download = fileName;
  a.click();
  // Remove the link when done
  document.body.removeChild(a);
}

export function formatBytes(bytes, decimals = 2) {
  if (!+bytes) return '0 Bytes'
  const k = 1024
  const dm = decimals < 0 ? 0 : decimals
  const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']
  const i = Math.floor(Math.log(bytes) / Math.log(k))
  return `${parseFloat((bytes / Math.pow(k, i)).toFixed(dm))} ${sizes[i]}`
}
